import Vue from "vue";
import Router from "vue-router";
import { getLocalStorageItem, tokensConstant } from "./Utility/LocalStorage";
import store from "./Store/store";
import { decodeToken } from "./Utility/DecodeJwt";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/StatusReports",
      name: "Sales",
      beforeEnter: requireAuth,
      component: () => import("./views/SalesReport/SalesReport"),
      meta: {
        title: "Leadership-Sales",
      },
    },

    {
      path: "/login",
      name: "login",
      beforeEnter: isAuthenticated,
      component: () => import("./views/Login/Login"),
      meta: {
        title: "Leadership-Login",
      },
    },
    {
      path: "/",
      name: "dashboard",
      beforeEnter: requireAuth,
      component: () => import("./views/Dashboard/Dashboard"),
      meta: {
        title: "Leadership-Dashboard",
      },
    },
    {
      path: "/chat_",
      name: "chat_",
      beforeEnter: requireAuth,
      component: () => import("./components/Chat/Home"),
      meta: {
        title: "Leadership-Chat",
      },
    },
    {
      path: "/profile",
      name: "Profile",
      beforeEnter: requireAuth,
      component: () => import("./views/EditProfile/EditProfile"),
      meta: {
        title: "Leadership-Profile",
      },
    },
    {
      path: "/manageusers",
      name: "manageusers",
      beforeEnter: requireAuth,
      component: () => import("./views/ManageUsers/ManageUsers"),
      meta: {
        title: "Leadership-ManageUsers",
      },
    },
    {
      path: "/unauthorizedpage",
      name: "unauthorizedpage",
      beforeEnter: requireAuth,
      component: () => import("./views/page401"),
      meta: {
        title: "Leadership-UnauthorizedPage",
      },
    },
    {
      path: "/fillprofile",
      name: "fillprofile",
      beforeEnter: requireAuth,
      component: () => import("./views/FillProfile"),
      meta: {
        title: "Leadership-FillProfile",
      },
    },
    {
      path: "/chat",
      name: "chat",
      beforeEnter: requireAuth,
      component: () => import("./components/Chat/ChatHomeLarge.vue"),
      meta: {
        title: "Leadership-Chat",
      },
    },
    {
      path: "/TelerikReport",
      name: "TelerikReport",
      props: true,
      beforeEnter: requireAuth,
      component: () => import("./views/TelerikReport/TelerikReport"),
      meta: {
        title: "Leadership-Telerik",
      },
    },
    {
      path: "/FileExplorer",
      name: "FileExplorer",
      beforeEnter: requireAuth,
      component: () => import("./views/FileExplorer/FileExplorer"),
      meta: {
        title: "Leadership-FileExplorer",
      },
    },
    {
      path: "/TelerikReportList",
      name: "TelerikReportList",
      props: true,
      beforeEnter: requireAuth,
      component: () => import("./views/TelerikReportList/TelerikReportList"),
      meta: {
        title: "Leadership-Telerik",
      },
    },
    {
      path: "/webinar",
      name: "webinar",
      props: true,
      beforeEnter: requireAuth,
      component: () => import("./views/Webinar/Webinar"),
      meta: {
        title: "Leadership-Webinar",
      },
    },
    {
      path: "/TownHall",
      name: "TownHall",
      props: true,
      beforeEnter: requireAuth,
      component: () => import("./views/TownHall/TownHall"),
      meta: {
        title: "TownHallList",
      },
    },
    {
      path: "/CallCenter",
      name: "CallCenter",
      props: true,
      beforeEnter: requireAuth,
      component: () => import("./views/CallCenter/CallCenter"),
      meta: {
        title: "TownHallList",
      },
    },

    {
      path: "/importpayroll",
      name: "importpayroll",
      beforeEnter: requireAuth,
      component: () => import("./views/ImportPayroll/ImportPayroll.vue"),
      meta: {
        title: "Leadership-ImportPayroll",
      },
    },
  ],
});

function isAuthenticated(to, from, next) {
  var accessToken = getLocalStorageItem(tokensConstant.AccessToken);
  var userClaims = decodeToken(accessToken);
  if (userClaims != null) {
    store.commit("setUser", userClaims);
    next({ name: "dashboard" });
  } else {
    next();
  }
}

function requireAuth(to, from, next) {
  var token = getLocalStorageItem(tokensConstant.AccessToken);
  var userClaims = decodeToken(token);
  if (userClaims == null) {
    next({ name: "login" });
  } else {
    var vuexStore = store;
    if (vuexStore.state.Report.reportMenus.length == 0) {
      vuexStore.commit("setUser", userClaims);
      vuexStore.dispatch("getAreaBranchTeamService");
      vuexStore.dispatch("getAllReportMenus");
    }
    next();
  }
}
